const retreiveData = key => {
    return JSON.parse(localStorage.getItem(key))
}

const saveData = (key, data) => {
    return localStorage.setItem(key, JSON.stringify(data))
}

//Search history
const MAX_SEARCHS_STORE_LENGTH = 30
export const getSearchHistory = () => retreiveData('search') || []
export const clearSearchHistory = () => saveData('search', [])

export const addSearchHistory = (category, title = '', author = '', subject = '') => {
    let storedData = getSearchHistory()

    const isExisting = storedData.find(obj =>
        obj.category === category && obj.title === title && obj.author === author && obj.subject === subject
    )

    if(isExisting) {
        storedData.splice(storedData.indexOf(isExisting), 1)
        storedData = [
            {category: category, title: title, author: author, subject: subject},
            ...storedData
        ]
        return saveData('search', storedData)
    }
    
    if(storedData.length >= MAX_SEARCHS_STORE_LENGTH)
        storedData.pop()

    storedData = [
        {category: category, title: title, author: author, subject: subject},
        ...storedData
    ]
    return saveData('search', storedData)
}


//Bookmarks
export const getBookmarks = () => retreiveData('bookmarks') || []

export const isBookmark = item => {
    return getBookmarks().find(obj =>
        obj.id === item['registro-sistema'] || obj.id === item.id
    )
}

export const addBookmark = item => {
    let storedData = getBookmarks()

    if(isBookmark(item))
        return

    storedData = [
        {
            id: item['registro-sistema'],
            title: item.titulo,
            author: item.autor,
            isRepository: false,
        },
        ...storedData
    ]
    return saveData('bookmarks', storedData)
}

export const addBookmarkRepository = item => {
    let storedData = getBookmarks()

    if(isBookmark(item))
        return

    storedData = [
        {
            id: item.id,
            title: item.title,
            author: item.authors,
            isRepository: true,
        },
        ...storedData
    ]
    return saveData('bookmarks', storedData)
}

export const removeBookmark = item => {
    let storedData = getBookmarks()
    const toRemove = isBookmark(item)

    if(toRemove)
        storedData.splice(toRemove, 1)
    
    return saveData('bookmarks', storedData)
}